import { instance } from './instance';
import {
  PartnerPayoutRunInput,
  PartnerPayoutPreview,
  PartnerPayoutAggregate,
  ConfigurePayoutRunInput,
  GrantPayoutBonusInput,
  PayoutRunInput,
  PayoutRunConfiguration,
  PayoutRunPreview,
  PayoutStatementRevision,
  PayoutStatementScheduleRun,
} from '../types/payout-runs.types';

export const payoutRunsApi = {
  readStatement: async (
    statementId: string
  ): Promise<PayoutStatementRevision> =>
    (await instance.get(`/payout/statements/${statementId}`)).data.data,
  previewPartner: async (
    payload: PartnerPayoutRunInput
  ): Promise<PartnerPayoutPreview> =>
    (await instance.post('/payout/runs/partner/preview', payload)).data.data,
  freezePartner: async (
    payload: PartnerPayoutRunInput
  ): Promise<PartnerPayoutAggregate> =>
    (await instance.post('/payout/runs/partner/freeze', payload)).data.data,
  cancel: async (
    statementId: string,
    reason: string
  ): Promise<PayoutStatementRevision> =>
    (
      await instance.post(`/payout/statements/${statementId}/cancel`, {
        reason,
      })
    ).data.data,
  grantBonus: async (payload: GrantPayoutBonusInput) =>
    (await instance.post('/payout/bonus-grants', payload)).data.data,
  configurations: async (): Promise<PayoutRunConfiguration[]> =>
    (await instance.get('/payout/run-configurations')).data.data,
  configure: async (payload: ConfigurePayoutRunInput) =>
    (await instance.post('/payout/run-configurations', payload)).data.data,
  preview: async (payload: PayoutRunInput): Promise<PayoutRunPreview> =>
    (await instance.post('/payout/runs/preview', payload)).data.data,
  freeze: async (payload: PayoutRunInput): Promise<PayoutStatementRevision> =>
    (await instance.post('/payout/runs/freeze', payload)).data.data,
  approve: async (statementId: string): Promise<PayoutStatementRevision> =>
    (await instance.post(`/payout/statements/${statementId}/approve`)).data
      .data,
  execute: async (statementId: string) =>
    (await instance.post(`/payout/statements/${statementId}/execute`)).data
      .data,
  scheduledRuns: async (): Promise<PayoutStatementScheduleRun[]> =>
    (await instance.get('/payout/runs/scheduled')).data.data,
  statements: async (riderId?: number): Promise<PayoutStatementRevision[]> =>
    (
      await instance.get('/payout/statements', {
        params: riderId === undefined ? {} : { riderId },
      })
    ).data.data,
};
